import { Category } from "@/types/guidebookType";

export const getTipContentPath = (category: Category, index: string) => {
  return `/guidebook/tip/${category}/${index}/`;
};

export const getEssentialContentPath = (category: Category, index: string) => {
  return `/guidebook/essential/${category}/${index}/`;
};
